import { render, staticRenderFns } from "./IwsVideo1.vue?vue&type=template&id=5548c060&scoped=true&"
import script from "./IwsVideo1.vue?vue&type=script&lang=js&"
export * from "./IwsVideo1.vue?vue&type=script&lang=js&"
import style0 from "./IwsVideo1.vue?vue&type=style&index=0&id=5548c060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5548c060",
  null
  
)

export default component.exports